import React, { useEffect, useState } from 'react';
import css from './AddToFavButton.module.css';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import routeConfiguration from '../../routing/routeConfiguration';
import { createResourceLocatorString, pathByRouteName } from '../../util/routes';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import Button from '../Button/Button';

const AddToFavButtonComponent = props => {
  const {
    currentUser, listing, smallFavButton, onUpdateProfile, type, listingPage,
    history, className
  } = props;
  const [isFavourite, setIsFavourite] = useState(false);
  const [favListingsArray, setFavListingsArray] = useState([]);
  const listingId = listing?.id?.uuid;
  let buttonClass = '';

  useEffect(() => {
    if (
      currentUser?.id?.uuid &&
      currentUser.attributes.profile.privateData &&
      currentUser.attributes.profile.privateData.favListingsArray
    ) {
      setFavListingsArray(currentUser.attributes.profile.privateData.favListingsArray);
      const listingsIdsArray = currentUser.attributes.profile.privateData.favListingsArray;
      const isFavourite = listingsIdsArray.find(id => {
        return id === listingId;
      });
      if (isFavourite) {
        setIsFavourite(true);
      } else {
        setIsFavourite(false);
      }
    }
  }, [currentUser]);

  const addToFavourites = action => {
    if( !currentUser?.id?.uuid ){
      history.push(createResourceLocatorString('LoginPage', routeConfiguration(), {}, {}));
    }

    if (action === 'add') {
      return onUpdateProfile({
        privateData: {
          favListingsArray: [...favListingsArray, listingId],
        },
      }).catch(e => console.log(e));
    } else {
      const favListingsArrayCopy = [...favListingsArray];

      for (var i = 0; i < favListingsArrayCopy.length; i++) {
        if (favListingsArrayCopy[i] === listingId) {
          favListingsArrayCopy.splice(i, 1);
        }
      }

      return onUpdateProfile({
        privateData: {
          favListingsArray: favListingsArrayCopy,
        },
      }).catch(e => console.log(e));
    }
  };

//  if (!currentUser?.id?.uuid) {
//    return null;
//  }

  if (type === 'button') {
    return (
      <Button
        type={'button'}
        // className={isFavourite ? css.actionButtonGreen : css.actionButtonBrown}
        className={isFavourite ? classNames( css.actionButtonGreen, className ) : className}
        onClick={() => {
          addToFavourites(isFavourite ? 'remove' : 'add');
        }}
      >
        {isFavourite ? 'Remove from watchlist' : 'Add to watchlist'}
      </Button>
    );
  }

  let favButtonWrapperClass = css.favButtonWrapper;

  if (listingPage) {
    favButtonWrapperClass = css.favButtonWrapperListingPage;
  }

  if (smallFavButton) {
    favButtonWrapperClass = css.favButtonWrapperSmall;
  }

  return (
    <div
      className={favButtonWrapperClass}
      onClick={e => {
        e.preventDefault();
      }}
      data-tooltip="Watchlist"
    >
      {!isFavourite ? (
        <div
          onClick={e => {
            e.preventDefault();
            addToFavourites('add');
          }}
          className={css.favButtonNotSelected}
        />
      ) : (
        <div
          onClick={e => {
            e.preventDefault();
            addToFavourites('remove');
          }}
          className={css.favButtonSelected}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const AddToFavButton = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(AddToFavButtonComponent);

export default AddToFavButton;
